import admin from "./_admin";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "../../setup/js/_swiper";
import "../../setup/js/_universalLink";
import "../../setup/js/_scrollwatch";
//import "../../setup/js/_language";
import vPortal from "../../setup/js/_vportal";
import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";

// import "lazysizes";
// import "@fancyapps/fancybox";
// $(document).ready(function () {
//     setTimeout(function () {
//         $("#wrapper").scalePlatform();
//     }, 4000)
//
//     $(".loading").each(function () {
//         setTimeout(() => {
//             $(".loading").removeClass("active");
//         }, 5000);
//     });
//     $(window).on("resize", function(){
//         setTimeout(function () {
//             $("#wrapper").scalePlatform();
//         }, 4000)
//     });
//
// });
$(document).ready(function () {
    $("#wrapper").scalePlatform();
    $(window).on("resize", function () {
        setTimeout(function () {
            $("#wrapper").scalePlatform();
        }, 2000)
    });

    $(".loading").each(function () {
        setTimeout(() => {
            $(".loading").removeClass("active");
        }, 500);
    });
});
window.addEventListener("load", function () {
    var url = new URL(window.location.href);
    var param_admin = url.searchParams.get("admin");
    admin.init();
    admin.executeFunctions();

    $("#wrapper").scalePlatform();
    $(window).on("resize", function () {
        $("#wrapper").scalePlatform();
    });
    commonLibs();
    $('[data-fancybox]').fancybox({
        caption: function (instance, item) {
            return $(this).find('figcaption').html();
        }
    });
});

var commonLibs = function () {


    $("#wrapper").scalePlatform();

    $(".onelink").each(function () {
        $(".onelink").universalLink();
    });
    $(".news").each(function () {
        var postsTag = "#" + $(this).attr("id");

        $().vPortal({
            container: postsTag, el: {
                tabContainer: ".news_tab > ul", resultContainer: ".news_list",
            }, paginationOptions: {}, after: function () {
                setTimeout(function () {
                    $("#wrapper").scalePlatform();
                }, 100)
            }
        });
    });
    $("#navBurger").each(function () {
        $("#navBurger").toggleClassname({
            toggle: [{
                el: $("#floattop"), className: 'active'
            }, {
                el: $("#floatnav"), className: 'active'
            }, {
                el: $("#navBurger"), className: 'is-active'
            }, {
                el: $("#navBurger"), className: 'active'
            }]
        });
    });

    $("#subwebBurger").each(function () {
        $("#subwebBurger").toggleClassname({
            toggle: [{
                el: $(".midbar__menu"), className: 'active'
            }, {
                el: $("#subwebBurger"), className: 'is-active'
            }]
        });
    });

    $("#asideRightToggle").each(function () {
        $(this).toggleClassname({
            toggle: [{
                el: $(".floatright__main"), className: 'active'
            }, {
                el: $(".floatright .aside"), className: 'active'
            }]
        });
    });

    $(".scrollTop").each(function () {
        $(this).on("click", function () {
            $("html, body").animate({scrollTop: 0}, 400)
        })
    })
    scrollFrame.init();
    scrollWatch.init({
        options: {
            onElementInView: function(e) {
                var $this = $(e.el).parents("[data-block-id]");
                var dataBlockId = $this.attr("data-block-id");
                $(`[data-fts-selector="[data-block-id='${dataBlockId}']"]`).addClass("active");
            },
            onElementOutOfView: function(e) {
                var $this = $(e.el).parents("[data-block-id]");
                var dataBlockId = $this.attr("data-block-id");
                $(`[data-fts-selector="[data-block-id='${dataBlockId}']"]`).removeClass("active");
            }
        }
    });
    // if ($("[data-lightbox]").length > 0) {
    //     $("[data-lightbox]").each(function () {
    //         $(this).lightBox({
    //             objLightBox: $(this).attr('href'),
    //             type: $(this).data('lightbox-type')
    //         });
    //     });
    // }
}

